import React from "react";

const PageHome3 = () => {
  return <div>PageHome3</div>;
};

export default PageHome3;
